<template>
  <p v-if="visibleSpan" :role="warning ? 'alert' : 'none'" class="opc-zmone__desc" :class="{ 'is-warning': warning }" @click='handleClick($event)'>
    <span v-html="text"></span>
    <slot />
  </p>
</template>

<script>
import { isBizPlusContext } from './common/utils';
import { unlockProLicenseCount, unlockBizLicenseCount } from '@/common/constants';

export default {
  props: {
    type: String,
    number: Number,
    invisibleCategory: {
      type: Array,
      default: () => [],
    },
    additionalSpans: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    spans() {
      return {
        pro: [
          {
            value: 1,
            text: this.$t('billing.zone.min_of_pro'),
          },
          {
            value: unlockProLicenseCount ? 99 : 9,
            default: true,
            text: unlockProLicenseCount ? this.$t('billing.zone.max_of_pro_99') : this.$t('billing.zone.max_of_pro'),
          },
        ],
        biz: [
          {
            value: unlockBizLicenseCount ? 1 : 10,
            text: isBizPlusContext ? (unlockBizLicenseCount ? '' : this.$t('billing.zone.biz_combined_bizplus')) : (unlockBizLicenseCount ? this.$t('billing.zone.min_of_biz_1') : this.$t('billing.zone.min_of_biz')),
            default: true,
          },
          {
            value: 99,
            text: this.$t('billing.zone.max_of_biz'),
          },
        ],
        zwb: [
          {
            value: 1,
            text: '',
          },
          {
            value: 99,
            text: this.$t('billing.zone.max_of_plans', [99, 100]),
          },
        ],
        proplus: [
          {
            value: 1,
            text: '',
          },
          {
            value: 99,
            text: this.$t('billing.zone.max_of_plans_user', [99, 100]),
          },
        ],
        ...this.additionalSpans
      }
    },
    visibleSpan() {
      if (this.invisibleCategory.includes(this.type)) {
        return null;
      }
      return this.spans[this.type]
    },
    warning() {
      return this.number >= this.visibleSpan?.[1]?.value;
    },
    text() {
      if (this.number == this.visibleSpan?.[1].value) {
        return this.visibleSpan?.[1].text;
      }
      if (this.number == this.visibleSpan?.[0].value) {
        return this.visibleSpan?.[0].text;
      }
      return this.visibleSpan.find((x) => x.default)?.text;
    },
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);
    }
  }
};
</script>
